<template>
  <v-container>
    <v-row>
      <v-col cols="12" v-for="(reactivo, index) in reactivos" :key="index">
        <v-row align="center">
          <v-col cols="1">
            {{ index + 1 }}
          </v-col>
          <v-col cols="8">
            <div class="text-subtitle-2">
              {{ reactivo.CatReactivo.title }}
            </div>
          </v-col>
          <v-col>
            <v-select
              label="Frecuencia de medición"
              v-model="evaluacion.reactivos[index].idFrecuencia"
              rounded
              filled
              dense
              :items="frecuencia"
              item-value="id"
              item-text="title"
              item-color="secondary"
              color="secondary"
              background-color="primary"
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="my-2"></v-divider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    evaluacion: {
      type: Object,
      required: true,
    },

    reactivos: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters('frecuenciaRespetoPrincipio', {
      frecuencia: 'getFrecuenciaRespetoPrincipio',
    }),
  },
}
</script>
